import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import VueLazyload from 'vue-lazyload'

import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import '@/assets/css/common.css'

import axios from 'axios'
Vue.prototype.$axios = axios

Vue.prototype.$EventBus = new Vue()

import i18n from './i18n'

import store from './store'

import VueResource  from 'vue-resource';
Vue.use(VueResource)

Vue.use(ElementUI)

Vue.use(VueLazyload,{
  preLoad:1,
  loading:require('./assets/img/other/loading.jpg'),
  attempt:5
})

Vue.config.productionTip = false

// 注释掉的网站或者订单 全局变量 // 为空则是全部订单都注释掉
// web全部小写
var outWebsGlobal=[
  {
    web:"tianruide",
    orders:[],// 为空则是全部订单都注释掉
  },
  // {
  //   web:"chenghuiru",
  //   orders:[],// 为空则是全部订单都注释掉
  // },
]
Vue.prototype.$outWebsGlobal = outWebsGlobal;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
